import "../CSS/itemEvento.css";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Link } from "react-router-dom";
import React, { useRef, useEffect, useState, Fragment } from "react";
import Button from "@mui/material/Button";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";

function ItemEvento(props) {
  const [isPaulet, setIsPaulet] = useState(true);

  const [fecha, setFecha] = useState(
    new Date(props.fecha.toString()).getDate() +
      " de " +
      getMonthName(new Date(props.fecha.toString()).getMonth() + 1) +
      " del " +
      new Date(props.fecha.toString()).getFullYear()
  );
  const [hora, setHora] = useState(
	props.fecha.toString().split(" ")[1]
      
  );
  function getMonthName(monthNumber) {
    if (monthNumber) {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      // Restamos 1 al mes porque el arreglo tiene índice 0 para Enero, 1 para Febrero, etc.
      return months[monthNumber - 1];
    }
  }
  useEffect(() => {
    console.log("Tipo de evento: " + props.salon);
    if (props.salon == "Salon de eventos") {
      setIsPaulet(false);
    } else {
      setIsPaulet(true);
    }
  }, []);
  return (
    <div className="evento-card">
      <div>
        <img
          id="imagenTienda"
          className="evento-logoEmpresa"
          src={props.imagen}
          alt="flecha"
        />
      </div>
      <div className="itemBody">
        <div className="evento-cabecera">
          <p>{props.nombre}</p>
          <p>Dia: {fecha}</p>
          <p>Hora : {hora}</p>
          <p>{props.descripcion}</p>
        </div>
        <div className="evento-detalles">
          {isPaulet ? (
            <Link to={`/eventos/${props.id}/registrarParticipante`}>
              <Button
                variant="contained"
                color="success"
                endIcon={<LocalActivityIcon />}
              >
                RESERVAR
              </Button>
            </Link>
          ) : (
            <Link to={`/eventos/${props.id}/ingresarPago`}>
              <Button
                variant="contained"
                color="success"
                endIcon={<LocalActivityIcon />}
              >
                RESERVAR
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default ItemEvento;
